module.exports = __webpack_public_path__ + "static/usafitness-9e2f7850a1750478b994d47a019109e7.png";